import { dateTimeFormater } from "../../utilities/formaters";

export default function Note(note) {
  return (
    <div>
      <div className="note">
        <span>
          {note.Author} - <small>{dateTimeFormater(note.Created)}</small>
        </span>
        <div>{note.Text}</div>
      </div>
    </div>
  );
}
